import HTTP from "@/_helpers/http";
import { NODEPOSITBONUS__API } from "@/_helpers/urls";
import { NODEPOSITBONUS__ACTIONS } from "../action-types";
import { NODEPOSITBONUS__MUTATIONS } from "../mutation-types";

const state = {
  nodepositbonus: [],
  noDepositBonusAccountInfo: {},
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1,
  },
  isLoading: false,
};

const getters = {};

const mutations = {
  [NODEPOSITBONUS__MUTATIONS.NODEPOSITBONUSACCOUNTINFO](state, payload) {
    state.noDepositBonusAccountInfo = payload;
  },

  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
};

const actions = {
  async [NODEPOSITBONUS__ACTIONS.CREATENODEPOSITBONUSACCOUNT](
    { dispatch },
    data
  ) {
    try {
      const response = await HTTP().post(
        NODEPOSITBONUS__API.CREATENODEPOSITBONUSACCOUNT,
        data
      );

      // refresh info after account creation
      await dispatch(NODEPOSITBONUS__ACTIONS.NODEPOSITBONUSACCOUNTINFO);

      return response.data;
    } catch (error) {
      throw error.response?.data || { message: "Something went wrong." };
    }
  },

  async [NODEPOSITBONUS__ACTIONS.NODEPOSITBONUSACCOUNTINFO]({ commit }) {
    try {
      const { data } = await HTTP().get(
        NODEPOSITBONUS__API.NODEPOSITBONUSACCOUNTINFO
      );
      commit(NODEPOSITBONUS__MUTATIONS.NODEPOSITBONUSACCOUNTINFO, data);
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
